import { useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

import { ISavedState } from 'features/RiskManagement/Assessments'
import SavedStateCard from 'features/RiskManagement/Assessments/Components/SavedStateCard'

interface IMonthAccordion {
  year: number
  monthList: {
    value: number
    states: ISavedState[]
  }
}

const MonthAccordion = ({ monthList, year }: IMonthAccordion) => {
  const [showContent, setShowContent] = useState<boolean>(true)

  const monthName = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ][monthList.value - 1]

  const handleExpandChange = (): void => {
    setShowContent(!showContent)
  }

  return (
    <>
      <button
        className={[
          'relative w-full border-b-2 border-gray-300',
          'p-1.5 text-gray-500',
          'text-left font-medium'
        ].join(' ')}
        onClick={handleExpandChange}
      >
        {monthName} {year}
        {showContent ? (
          <ExpandLessIcon className='absolute right-3.5' fontSize='small' />
        ) : (
          <ExpandMoreIcon className='absolute right-3.5' fontSize='small' />
        )}
      </button>
      {showContent && (
        <div
          className={[
            'grid grid-flow-row gap-4 p-5',
            'grid-cols-2',
            '2xl:grid-cols-3'
          ].join(' ')}
        >
          {monthList.states.map((state) => (
            <SavedStateCard key={state.id} state={state} />
          ))}
        </div>
      )}
    </>
  )
}

export default MonthAccordion
